import { IReviewItem } from '../../types'
import { useCallback, useEffect, useState } from 'react'

import ReviewBySchoolItem from './ReviewBySchoolItem'

interface IReviewProps {
  reviewList: IReviewItem[]
}

const FullReviewBySchool = ({ reviewList }: IReviewProps) => {
  const [viewReviewList, setViewReviewList] = useState<IReviewItem[]>([])
  const onClickMoreReview = useCallback(() => {
    const reviews = reviewList.slice(0, viewReviewList.length + 4)
    setViewReviewList(reviews)
  }, [reviewList, viewReviewList.length])

  useEffect(() => {
    const reviews = reviewList.slice(0, 4)
    setViewReviewList(reviews)
  }, [])

  return (
    <div>
      <div className="box-border flex w-full items-start rounded-md bg-yellow-450 bg-opacity-10 px-2 py-4 md:items-center">
        <div className="w-12">
          <img src="/img/custom_chat_icon.png" alt="chat icon" className="w-full" />
        </div>
        <div className="ml-1">
          <p className="break-keep font-semibold text-trueGray-500">
            수강후기는 수료생이 100% 직접 작성한 내용입니다.
          </p>
          <p className="mt-1 break-keep text-sm text-trueGray-500">
            맞춤법 및 오타만 수정하였습니다.
          </p>
        </div>
      </div>
      <ul className="mt-6">
        {viewReviewList.map(item => {
          return <ReviewBySchoolItem key={item.id} item={item} />
        })}
      </ul>
      {viewReviewList.length < reviewList.length && (
        <div className="flex justify-center">
          <button
            onClick={onClickMoreReview}
            className="w-full rounded-md border border-trueGray-300 px-10 py-3 text-sm font-semibold text-trueGray-500 md:text-base">
            수강후기 더 보기
          </button>
        </div>
      )}
    </div>
  )
}

export default FullReviewBySchool
